import { InvoiceCreditOverviewEffect } from './invoice-credit-overview.effect';
import { InvoiceCreditDetailsEffect } from './invoice-credit-details.effect';

export const effects: any[] = [
  InvoiceCreditOverviewEffect,
  InvoiceCreditDetailsEffect,
];
